'use client';

import { Collapsible } from '@/components/ui/collapsible';
import { playSfx } from '@/hooks/use-sound';

/**
 * Collapsible root that plays the open/close UI sound on toggle. Client
 * boundary so the "Show more/less" lists (awards, certifications, projects)
 * can stay server components while still making a sound.
 */
export function SoundCollapsible({
  children,
  ...props
}: React.ComponentProps<typeof Collapsible>) {
  return (
    <Collapsible
      onOpenChange={(open) => playSfx(open ? 'open' : 'close')}
      {...props}
    >
      {children}
    </Collapsible>
  );
}
